import * as React from 'react';
import { AutoSizer } from 'react-virtualized';
import styled from 'styled-components';
import { IProfileReportState } from '../../../../data/providers/reports/profileReportProvider';
import { Entity, EZScorePreference, ISize } from '../../../../data/types';
import { Column } from '../../../layout/Column';
import { Row } from '../../../layout/Row';
import { Card } from '../../../shared/card/Card';
import { CardBody } from '../../../shared/card/CardBody';
import { GraphContainer } from '../../../shared/graphs/GraphContainer';
import { Notable } from '../../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../../shared/pdf/Pdf';
import { colors } from '../../colors';
import { ProfileRadar } from './ProfileRadar';
import { TsaExplainer } from './TsaExplainer';

interface IProps {
  pdfMode: EPdfMode;
  reportState: IProfileReportState;
  entity: Entity;
}

export const GraphCard = (props: IProps): React.ReactElement => {
  return (
    <React.Fragment>
      <Row>
        <Notable pdf={isPdf(props.pdfMode)}>
          <Card
            noTopRadius
            inverse={shouldInvert(props.pdfMode)}
            style={{
              padding: '0px',
              minHeight: 'var(--graph-min-height)',
            }}
          >
            <Column>
              <CardBody withoutFooter>
                <GraphContainer inverse={shouldInvert(props.pdfMode)}>
                  <div
                    style={{
                      height: '100%',
                      width: '100%',
                    }}
                    className='graph-parent'
                  >
                    <AutoSizer>
                      {(size: ISize): React.ReactElement => {
                        return (
                          <React.Fragment>
                            <RadarLegend entity={props.entity} />
                            <ProfileRadar
                              scaled={
                                props?.reportState?.comparisonPopulation
                                  .zScorePreference === EZScorePreference.Scaled
                              }
                              isPdf={isPdf(props.pdfMode)}
                              data={props.reportState.data}
                              height={size.height}
                              width={size.width}
                            />
                          </React.Fragment>
                        );
                      }}
                    </AutoSizer>
                  </div>
                </GraphContainer>
              </CardBody>
            </Column>
          </Card>
        </Notable>
      </Row>
      <TSARow>
        <h3>Total Score of Athleticism: {props.reportState.tsa}</h3>
        <TsaExplainer />
      </TSARow>
    </React.Fragment>
  );
};

interface IRadarLegendProps {
  entity: Entity;
}

const RadarLegend = (props: IRadarLegendProps): React.ReactElement => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        right: 10,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginRight: '10px',
        }}
      >
        <div>{props.entity.name}</div>
        <div
          style={{
            height: '20px',
            width: '20px',
            borderRadius: '50%',
            marginLeft: '2.5px',
            backgroundColor: colors[0],
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div>Population</div>
        <div
          style={{
            height: '20px',
            width: '20px',
            borderRadius: '50%',
            marginLeft: '2.5px',
            backgroundColor: colors[1],
          }}
        />
      </div>
    </div>
  );
};

const TSARow = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 10px auto 0px auto;
  width: 100%;
`;
